import React, { useContext, useEffect, useRef } from 'react';
import theme from '../theme/theme';
import { calcCompletion, calcGroup, getMatchDetails, getPredictionDetails, 
         randomString as generateRandomString } from '../utils';
import { useNavigate, useParams } from "react-router-dom";
import { Box, Button, Grid, Typography, useMediaQuery } from "@mui/material";
import { globalStore } from '../state/store';
import { BorderLinearProgress, BottomNav, ButtonMatch, DisplayTeam, Header, 
         TableGroup, TextFieldScore } from '../components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { updatePrediction } from '../services/predictionService';

const Match = () => {

  const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

  const dayjs = require('dayjs')
  const navigate = useNavigate();
  const { matchid } = useParams();
  const [state, dispatch] = useContext(globalStore);
  const { match, homeTeam, awayTeam, stadium } = getMatchDetails(state, matchid);
  const group = calcGroup(match.groupRef, state.groups, state.teams, state.matches, state.prediction)
  const prediction = getPredictionDetails(state, matchid);

  const [enableTabToContinue, setEnableTabToContinue] = React.useState(false);
  const [isWindowFocused, setIsWindowFocused] = React.useState(true);
  const homeFieldIsDefined = prediction.home !== undefined && prediction.home !== null && prediction.home !== ''
  const awayFieldIsDefined = prediction.away !== undefined && prediction.away !== null && prediction.away !== ''
  const inputRefHome = useRef(null);
  const inputRefAway = useRef(null);

  // TODO - this filters for group, would need to consider how it'll work for knockout stage matches
  const orderedMatches = state.matches.filter((m) => m.stage === 'group').sort((a,b) => (a.date > b.date) ? 1 : ((b.date > a.date) ? -1 : 0));
  const curMatchIndex = orderedMatches.findIndex((m) => m._id === matchid);
  const prevMatch = curMatchIndex > 0 && orderedMatches[curMatchIndex - 1] !== undefined ? getMatchDetails(state, orderedMatches[curMatchIndex - 1]._id) : null
  const nextMatch = curMatchIndex < orderedMatches.length - 1 && orderedMatches[curMatchIndex + 1] !== undefined ? getMatchDetails(state, orderedMatches[curMatchIndex + 1]._id) : null 
  const hasPrevMatch = prevMatch !== null && prevMatch.homeTeam !== undefined && prevMatch.homeTeam !== null
  const hasNextMatch = nextMatch !== null && nextMatch.homeTeam !== undefined && nextMatch.homeTeam !== null

  const exitRoute = match !== null ? '/predict/groups' : '/predict/groups' // TODO : if you exit from a knockout match then you need to go to the knockout overview

  useEffect(() => { // Update "tabToContinue", enable when both fields are filled and you're not focused on the first input
    if(homeFieldIsDefined && // Home score is completed
    prediction.away !== undefined && prediction.away !== null && prediction.away !== '' && // Away score is completed
    hasNextMatch // There is a next match
    // && awayFieldIsFocused // You're focused on the Away score input field
    ) {
      setEnableTabToContinue(true)
    } else {
      setEnableTabToContinue(false)
    }
  })

  useEffect(() => { // Add an event listener to check for the "enter" key
    function handleKeyDown(e) {

      if(e.keyCode === 13 && homeFieldIsDefined && awayFieldIsDefined && isWindowFocused && hasNextMatch) {
        e.preventDefault()
        fafPrediction();
        navigate('/match/' + nextMatch.match._id)
      }

      /*
      //let canUseArrows = (!homeFieldIsFocused || !homeFieldIsDefined) && (!awayFieldIsFocused || !awayFieldIsDefined)
      if(e.keyCode === 9 && !e.shiftKey && enableTabToContinue) {
        e.preventDefault()
        console.log("override tab")
        //inputRefAway.current.focus()
        //fafPrediction();
        //navigate('/match/' + nextMatch.match._id)
      }
        */
    }

    //document.addEventListener("keydown", handleKeyDown);
    window.addEventListener("focus", handleWindowFocus);
    window.addEventListener("blur", handleWindowBlur);
    document.addEventListener("keydown", handleKeyDown);

    return function cleanup() { 
      window.removeEventListener("focus", handleWindowFocus);
      window.removeEventListener("blur", handleWindowBlur);
      document.removeEventListener("keydown", handleKeyDown);
    };
    //return function cleanup() { document.removeEventListener("keydown", handleKeyDown); };
  })

  useEffect(() => {
    if(!homeFieldIsDefined) {
      inputRefHome.current.focus();
    } else {
      inputRefHome.current.blur();
    }
  }, [matchid])

  function handleWindowFocus() {
    setIsWindowFocused(true);
  }

  function handleWindowBlur() {
    setIsWindowFocused(false);
  }

  /*
  useEffect(() => {
    const handleFocus = () => console.log("Input focused");
    const handleBlur = () => console.log("Input blurred");

    if (inputRefAway.current) {
      console.log("setting")
      inputRefAway.current.addEventListener("focus", handleFocus);
      inputRefAway.current.addEventListener("blur", handleBlur);
    }

    // Cleanup on unmount
    return () => {
      if (inputRefAway.current) {
        console.log("cleaning")
        inputRefAway.current.removeEventListener("focus", handleFocus);
        inputRefAway.current.removeEventListener("blur", handleBlur);
      }
    };
  }, []);*/

  const fafPrediction = () => {
    updatePrediction({uid: state.user.uid, prediction: state.prediction})
  }

  const handlePredictionChange = (side, newVal) => {
    
    dispatch({
      type: prediction._id !== undefined ? "UPDATE_PREDICTION" : "ADD_PREDICTION",
      payload: { 
        _id: prediction._id !== undefined ? prediction._id : generateRandomString(20), 
        matchid: matchid, 
        stage: 'group',
        home: side === "home" ? newVal : prediction._id !== undefined ? prediction.home : undefined, 
        away: side === "away" ? newVal : prediction._id !== undefined ? prediction.away : undefined 
      },
    })

    // TODO - when final prediction - auto-calc all teams for 16th finals (noting that there may have already been some selected manually)

  }

  // Defines whether the "Home score" input field is focused or not, this helps to define "tabToContinue"
  /*const trackTextFieldFocus = (type, newVal) => {
    console.log("trackTextFieldFocus", homeFieldIsFocused, awayFieldIsFocused)
    if(type === "home") { setHomeFieldIsFocused(newVal) }
    else if(type === "away") { setAwayFieldIsFocused(newVal) }
  }*/

  return (
    <Box sx={{display: 'flex'}}>

      <Header page={"Predict"} />
      <BottomNav page={"Predict"} />

      <Box component="main" 
      sx={{ flexGrow: 1, mt: 8, p: 3, pt: isSmUp ? 5 : 1, backgroundColor: theme.palette.grey[200], minHeight: '100vh' }}>

        {/*
        <Grid container direction="row" justifyContent="flex-end">
          <Tooltip title={"Back to Overview"} placement="left">
            <IconButton onClick={(e) => { fafPrediction(); navigate(exitRoute) }}>
              <FontAwesomeIcon icon={faTimes} style={{fontSize: isSmUp ? '40px' : '20px', padding: isSmUp ? '8px 16px 8px 16px' : '8px 12px 8px 12px'}} />
            </IconButton>
          </Tooltip>
        </Grid>
        */}

        { // An error occured
        match === null || homeTeam === null || awayTeam === null || stadium === null ?
        <Box sx={{my: 5}}>
          <Typography variant="h5" color="error" align="center">Unable to find the match details</Typography>
          <Grid container justifyContent="center" sx={{pt:5}}>
            <Button onClick={e => navigate(exitRoute)}>
              <FontAwesomeIcon icon={faArrowLeft} />&nbsp;&nbsp;Back to the overview
            </Button>
          </Grid>
        </Box>
        : // No error - display the match
        <Box mt={4}>

          <Grid container direction="row" justifyContent="space-between">

            <Grid item xs={isMdUp ? 4 : 3}>
              <DisplayTeam team={homeTeam} />
            </Grid>
            <Grid item xs={isMdUp ? 4 : 6}>

              <Grid container direction="row" justifyContent="center" alignItems="center" spacing={isSmUp ? 3 : 2}>
                <Grid item>

                  <TextFieldScore
                    type="home"
                    autoFocus={!homeFieldIsDefined}
                    value={homeFieldIsDefined ? prediction.home : ''}
                    //onChange={e => handlePredictionChange("home", e.target.value)}
                    handlePredictionChange={handlePredictionChange}
                    //trackTextFieldFocus={trackTextFieldFocus}
                    //onFocusChange={setIsHomeFocused}
                    inputRef={inputRefHome}
                  />
                  
                </Grid>
                <Grid item>
                  -
                </Grid>
                <Grid item>

                  <TextFieldScore
                    type="away"
                    autoFocus={homeFieldIsDefined && !awayFieldIsDefined}
                    value={awayFieldIsDefined ? prediction.away : ''}
                    //onChange={e => handlePredictionChange("away", e.target.value)}
                    handlePredictionChange={handlePredictionChange}
                    //trackTextFieldFocus={trackTextFieldFocus}
                    //inputRef={inputRef2}
                    enableTabToContinue={enableTabToContinue}
                    inputRef={inputRefAway}
                    nextMatch={nextMatch}
                  />
                </Grid>
              </Grid>
              <Box sx={{mt: isMdUp ? 4 : 3}}>
                <Typography align="center" variant="body2" color="textSecondary" sx={{ fontSize: isSmUp ? '13px' : '11px'}}>
                  {dayjs(match.date).format('D MMM. YYYY h:mm A')}<br/>
                  {stadium.name}
                </Typography>

              </Box>
            </Grid>
            <Grid item xs={isMdUp ? 4 : 3}>
              <DisplayTeam team={awayTeam} />
            </Grid>
          </Grid>

          {group !== undefined && group !== null && group.length > 0 ?
          <Grid container direction="row" justifyContent="center" 
          alignItems="center" sx={{mt: isMdUp ? 10 : isSmUp ? 5 : 3}}>

            <Grid item>
              <TableGroup group={group} />
            </Grid>

          </Grid>
          :''}

          <Grid container direction="row" justifyContent="space-between" alignItems="flex-end" 
          sx={{position: isMdUp ? 'fixed' : 'relative', px: isSmUp ? 4 : 0, pb: isMdUp ? 0 : 6, pt: isMdUp ? 0 : isSmUp ? 12 : 10, bottom: '40px', left: '0px', width: '100%'}}>

            <Grid item>
              {hasPrevMatch ?
                <ButtonMatch match={prevMatch} type="left" click={e => navigate('/match/' + prevMatch.match._id)} />
              : // else a "fake box" of the same width as a buttonMatch 
              <Box sx={{width: '222px'}}>&nbsp;</Box>}
            </Grid>
            <Grid item xs={3} sx={isMdUp ? {} : { display: 'none'}}>

              <Typography variant="body2" color="textSecondary" align="center" sx={{mb:1}}>
                Group Stage: <span className="bold">{calcCompletion("weuro2025", "group", state.prediction, state.matches)}% complete</span>
              </Typography>

              <Box sx={{mb:2}}>
              <BorderLinearProgress value={calcCompletion("weuro2025", "group", state.prediction, state.matches)} />
              </Box>

            </Grid>
            <Grid item>
              <Grid item>
                {homeFieldIsDefined && awayFieldIsDefined && isWindowFocused && hasNextMatch ?
                <Typography align="center" sx={{ mb: 2, color: theme.palette.grey[800] }} className="boldest">
                  Press "Enter" to continue
                </Typography>
                :''}
                {hasNextMatch ?
                  <ButtonMatch /*enableTabToContinue={enableTabToContinue}*/ 
                  boost={homeFieldIsDefined && awayFieldIsDefined && isWindowFocused && hasNextMatch}
                  match={nextMatch} type="right" click={e => { fafPrediction(); navigate('/match/' + nextMatch.match._id) }} />
                : // else a "fake box" of the same width as a buttonMatch 
                <Box sx={{width: '222px'}}>
                  <Button onClick={e=> navigate('/predict/knockout')}
                  variant="text" size="large" 
                  sx={{padding: '10px 30px 10px 30px', marginLeft: '10px', fontWeight: '800'}}>To Knockout&nbsp;&nbsp;<FontAwesomeIcon icon={faArrowRight} /></Button>
                </Box>}
              </Grid>
            </Grid>
          </Grid>
        </Box>
        }
      </Box>
    </Box>
  );
}

export default Match;

// return true if passing nextProps to render would return the same result as passing prevProps to render, otherwise return false
/*function areEqual(prevProps, nextProps) {

  let equal = true;

  console.log("prevProps", prevProps)
  console.log("nextProps", nextProps)
 
  if(1 === 2) { // Conditions when to rerender
     equal = false;
  } 
  return equal
}
export default React.memo(Match, areEqual);*/



